"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAllValues = selectAllValues;
exports.selectValue = selectValue;
exports.selectFormMeta = selectFormMeta;
exports.iterateTerms = iterateTerms;
exports.eachTerm = eachTerm;
const reference_tables_1 = require("./reference-tables");
function selectAllValues(state, modelKey) {
    const referenceTable = reference_tables_1.referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    const formState = state[modelKey];
    const values = {};
    for (const [key, node] of Object.entries(reference_tables_1.referenceTables[modelKey].keyToNode)) {
        const term = node.type === "iterable-term"
            ? formState.iterables[node.iterableName].instances[node.iterableIndex]
                ?.terms[node.termName]
            : formState.terms[node.termName];
        values[key] = term ? term.value : "";
    }
    return values;
}
function selectValue(state, modelKey, termKey, property = "value") {
    const formState = state[modelKey];
    if (!formState)
        throw new Error(`No form for "${modelKey}"`);
    const node = reference_tables_1.referenceTables[modelKey].keyToNode[termKey];
    if (!node)
        throw new Error(`No key of "${termKey}" in "${modelKey}" form`);
    const term = node.type === "iterable-term"
        ? formState.iterables[node.iterableName].instances[node.iterableIndex]
            ?.terms[node.termName]
        : formState.terms[node.termName];
    return term ? term[property] : "";
}
function selectFormMeta(modelKey) {
    const referenceTable = reference_tables_1.referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    return referenceTable.model.meta;
}
function* iterateTerms(state, modelKey) {
    const referenceTable = reference_tables_1.referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    const model = reference_tables_1.referenceTables[modelKey].model;
    const formState = state[modelKey];
    for (const [key, node] of Object.entries(reference_tables_1.referenceTables[modelKey].keyToNode)) {
        if (node.type === "iterable-term") {
            yield [
                key,
                formState.iterables[node.iterableName].instances[node.iterableIndex]
                    ?.terms[node.termName],
                model.iterables[node.iterableName].terms[node.termName],
                model.iterables[node.iterableName],
                node.iterableIndex,
            ];
        }
        else {
            yield [
                key,
                formState.terms[node.termName],
                model.terms[node.termName],
                undefined,
                undefined,
            ];
        }
    }
}
function eachTerm(state, modelKey, callback) {
    const referenceTable = reference_tables_1.referenceTables[modelKey];
    if (!referenceTable)
        throw new Error(`No form for "${modelKey}"`);
    const model = reference_tables_1.referenceTables[modelKey].model;
    const formState = state[modelKey];
    for (const [key, node] of Object.entries(reference_tables_1.referenceTables[modelKey].keyToNode)) {
        if (node.type === "iterable-term") {
            callback(key, formState.iterables[node.iterableName].instances[node.iterableIndex]
                ?.terms[node.termName], model.iterables[node.iterableName].terms[node.termName], model.iterables[node.iterableName], node.iterableIndex);
        }
        else {
            callback(key, formState.terms[node.termName], model.terms[node.termName], undefined, undefined);
        }
    }
}
//# sourceMappingURL=selectors.js.map